/**
 * 专栏
 * 专栏API
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ColumnBaseVo from './ColumnBaseVo';




  /**
   * The PagingColumnVo model module.
   * @module column/model/PagingColumnVo
   * @version 0.1.0
   */

  /**
   * Constructs a new <code>PagingColumnVo</code>.
   * @alias module:column/model/PagingColumnVo
   * @class
   * @param totalRow {Integer} 总行数
   * @param pageSize {Integer} 每页展示数量
   * @param list {Array.<module:column/model/ColumnBaseVo>} 对象列表
   * @param pageNumber {Integer} 当前页码
   * @param lastPage {Boolean} 是否最后一页
   * @param firstPage {Boolean} 是否第一页
   * @param totalPage {Integer} 总页数
   */
  var exports = function(totalRow, pageSize, list, pageNumber, lastPage, firstPage, totalPage) {
    var _this = this;

    _this['totalRow'] = totalRow;
    _this['pageSize'] = pageSize;
    _this['list'] = list;
    _this['pageNumber'] = pageNumber;
    _this['lastPage'] = lastPage;
    _this['firstPage'] = firstPage;
    _this['totalPage'] = totalPage;
  };

  /**
   * Constructs a <code>PagingColumnVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:column/model/PagingColumnVo} obj Optional instance to populate.
   * @return {module:column/model/PagingColumnVo} The populated <code>PagingColumnVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'totalRow')) {
        obj['totalRow'] = ApiClient.convertToType(data['totalRow'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pageSize')) {
        obj['pageSize'] = ApiClient.convertToType(data['pageSize'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'list')) {
        obj['list'] = ApiClient.convertToType(data['list'], [ColumnBaseVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pageNumber')) {
        obj['pageNumber'] = ApiClient.convertToType(data['pageNumber'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'lastPage')) {
        obj['lastPage'] = ApiClient.convertToType(data['lastPage'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'firstPage')) {
        obj['firstPage'] = ApiClient.convertToType(data['firstPage'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'totalPage')) {
        obj['totalPage'] = ApiClient.convertToType(data['totalPage'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * 总行数
   * @member {Integer} totalRow
   */
  exports.prototype['totalRow'] = undefined;
  /**
   * 每页展示数量
   * @member {Integer} pageSize
   */
  exports.prototype['pageSize'] = undefined;
  /**
   * 对象列表
   * @member {Array.<module:column/model/ColumnBaseVo>} list
   */
  exports.prototype['list'] = undefined;
  /**
   * 当前页码
   * @member {Integer} pageNumber
   */
  exports.prototype['pageNumber'] = undefined;
  /**
   * 是否最后一页
   * @member {Boolean} lastPage
   */
  exports.prototype['lastPage'] = undefined;
  /**
   * 是否第一页
   * @member {Boolean} firstPage
   */
  exports.prototype['firstPage'] = undefined;
  /**
   * 总页数
   * @member {Integer} totalPage
   */
  exports.prototype['totalPage'] = undefined;



  export default exports;
;


